<template>
  <section>
    <h4>房舍修繕、水電維護 工作人員</h4>
    <h5>工作內容：</h5>
    <p>
      本會講堂、書庫、檀林及華藏園區之房舍，<br>
      各項修繕保養、水電設備裝修維護、土木雜項工程之施作及管理等。
    </p>
    <h5>條件：</h5>
    <p>願發心護持正法，為大眾服務，負責盡職之三寶弟子。</p>
    <h5>方式：</h5>
    <p>
      有意應徵者，請將履歷、照片及自傳(學佛歷程)，<br>
      以面交、E-MAIL或函寄至本會：<br>
      「台北市100中正區杭州南路一段55號３樓」總務組 楊師姐 收<br>
      電話：<a href="tel:+886-2-23951198">{{ $i18n.locale === 'tw' ? '0' : '+886-' }}2-23951198</a>轉分機35<br>
      傳真：02-23913415<br>
      E-mail：<a href="mailto:scyang@budaedu.org">scyang@budaedu.org</a>
    </p>
    <p>合者通知面洽，不適者恕不退回履歷資料。</p>
  </section>
</template>
<script>
import Vue from 'vue'

import i18n from '@/plugins/i18n.js'

export default {
  i18n,
  name: "building-renovation-and-water-and-electricity-maintenance-staff",
  props: {
    // 
  },
  data() {
    return {
      // 
    }
  },
  methods: {
    // 
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
  },
  components: {
    // 
  }
}
</script>